var _defs, _sodipodiNamedview;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMadeInLuxembourg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    id: "svg2",
    xmlSpace: "preserve",
    width: 682.62665,
    height: 546.77332,
    viewBox: "0 0 682.62665 546.77332",
    sodipodiDocname: "made_in_luxembourg_eps.eps",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "",
    bordercolor: "",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 640,
    "inkscapeWindow-height": 480,
    id: "namedview4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "ink_ext_XXXXXX",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,546.77333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1120.81,1277.67 172.63,-398.811 173.26,398.811 96.4,-502.139 h -54.18 l -61.12,321.309 h -1.26 L 1293.44,756 1140.97,1096.84 h -1.26 L 1078.6,775.531 h -54.18 l 96.39,502.139",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1873.04,1149.76 1791.76,959.5 h 160.66 z m -102.7,-239.408 -57.33,-134.821 h -57.97 l 219.26,497.719 213.58,-497.719 h -58.59 l -56.08,134.821 h -202.87",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2306.46,824.668 c 57.97,0 106.48,8.191 149.95,49.141 39.06,36.543 59.22,86.32 59.22,139.241 0,54.19 -20.79,106.48 -61.74,142.39 -43.47,38.43 -91.35,45.99 -147.43,45.99 h -38.43 V 824.668 Z m -91.35,425.912 h 89.47 c 71.19,0 129.15,-9.46 185.22,-57.34 54.19,-46.62 78.76,-110.25 78.76,-180.82 0,-69.311 -25.2,-130.42 -77.5,-177.041 -56.7,-50.399 -113.4,-59.848 -187.74,-59.848 h -88.21 v 475.049",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2717.84,1250.58 h 246.34 v -49.15 H 2770.77 V 1060.3 h 187.75 v -49.14 H 2770.77 V 824.668 h 193.41 v -49.137 h -246.34 v 475.049",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3453.68,775.531 h -52.93 v 475.049 h 52.93 V 775.531",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3628.81,1270.73 370.47,-388.089 v 367.939 h 52.91 V 754.102 L 3681.74,1141.58 V 775.531 h -52.93 v 495.199",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 260.551,68.668 H 391.602 V 19.5313 H 207.629 V 494.578 h 52.922 V 68.668",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 571.145,211.691 c 0,-35.281 -1.262,-75.609 20.789,-105.839 20.793,-28.9926 61.113,-45.3637 95.765,-45.3637 34.02,0 71.192,15.7422 93.242,42.2027 25.207,30.25 23.317,71.829 23.317,109 V 494.578 H 857.18 V 197.199 c 0,-51.66 -3.782,-92.609 -41.582,-131.6677 -32.766,-35.293 -80.016,-54.1915 -127.899,-54.1915 -44.73,0 -90.726,17.0118 -122.855,48.5118 -41.582,39.6875 -46.625,83.1684 -46.625,137.3474 v 297.379 h 52.926 V 211.691",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 998.906,494.578 h 60.484 l 97.03,-178.937 97.02,178.937 h 60.49 L 1185.4,265.238 1325.89,19.5313 h -60.48 L 1156.42,214.84 1047.42,19.5313 H 986.934 L 1127.43,265.238 998.906,494.578",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1457.54,494.578 h 246.35 V 445.441 H 1510.47 V 304.309 h 187.75 V 255.172 H 1510.47 V 68.668 h 193.42 V 19.5313 H 1457.54 V 494.578",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1931.3,521.672 172.64,-398.813 173.26,398.813 96.39,-502.1407 h -54.18 L 2258.3,340.852 h -1.26 L 2103.94,0 1951.46,340.852 h -1.25 L 1889.09,19.5313 h -54.18 l 96.39,502.1407",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2562.56,68.668 h 52.92 c 59.23,0 121.6,14.4922 121.6,86.941 0,73.731 -70.57,84.43 -128.53,84.43 h -45.99 z m 0,216.742 h 20.16 c 59.85,0 110.88,6.922 110.88,80.641 0,71.82 -45.35,79.39 -110.26,79.39 h -20.78 z m -52.93,209.168 h 78.13 c 86.32,0 158.77,-31.5 158.77,-128.527 0,-38.43 -14.49,-71.199 -46.62,-92.61 C 2756.61,259.57 2790,208.539 2790,151.84 2790,57.332 2713.77,19.5313 2619.89,19.5313 H 2509.63 V 494.578",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2972.06,257.051 c 0,-107.102 86.95,-196.5627 194.68,-196.5627 107.74,0 194.69,89.4607 194.69,196.5627 0,107.738 -85.7,196.57 -194.69,196.57 -109,0 -194.68,-88.832 -194.68,-196.57 z m 442.28,-0.629 c 0,-136.711 -112.15,-245.0822 -247.6,-245.0822 -135.47,0 -247.59,108.3712 -247.59,245.0822 0,136.09 112.12,246.34 247.59,246.34 135.45,0 247.6,-110.25 247.6,-246.34",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3613.38,211.691 c 0,-35.281 -1.25,-75.609 20.8,-105.839 20.79,-28.9926 61.12,-45.3637 95.77,-45.3637 34.02,0 71.19,15.7422 93.24,42.2027 25.21,30.25 23.32,71.829 23.32,109 v 282.887 h 52.93 V 197.199 c 0,-51.66 -3.79,-92.609 -41.58,-131.6677 -32.78,-35.293 -80.02,-54.1915 -127.91,-54.1915 -44.73,0 -90.73,17.0118 -122.86,48.5118 -41.58,39.6875 -46.62,83.1684 -46.62,137.3474 v 297.379 h 52.91 V 211.691",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4121.8,274.699 h 16.39 c 59.86,0 120.33,11.332 120.33,85.051 0,78.121 -57.32,85.691 -120.96,85.691 h -15.76 z m 0,-255.1677 h -52.91 V 494.578 h 68.67 c 90.1,0 173.89,-23.949 173.89,-131.047 0,-73.082 -46,-124.75 -119.08,-131.051 L 4343.58,19.5313 H 4278.7 L 4135.04,228.078 H 4121.8 V 19.5313",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4927.6,258.309 c 1.25,-64.258 -5.68,-117.18 -49.16,-167.5902 -43.45,-50.3985 -109.61,-79.379 -175.76,-79.379 -133.57,0 -244.47,110.8902 -244.47,244.4492 0,136.09 110.9,246.973 247.62,246.973 83.16,0 150.56,-37.172 200.97,-102.692 l -38.44,-35.91 c -39.68,56.07 -93.24,89.461 -163.16,89.461 -108.38,0 -194.06,-91.351 -194.06,-198.449 0,-50.41 20.15,-98.301 55.45,-134.203 34.65,-34.6487 85.06,-60.4807 134.82,-60.4807 82.54,0 169.47,60.4807 169.47,148.6837 h -141.11 v 49.137 h 197.83",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1284.02,2926.35 c -112.41,54.12 -238.41,84.45 -371.52,84.45 -473.582,0 -857.5,-383.92 -857.5,-857.5 0,-39.98 2.7344,-79.31 8.0273,-117.83 0,0 8.379,-78.71 113.5777,-420.3 L 338.453,1013.52 385,840.801 m 899.02,2085.549 c 1.24,-0.59 2.44,-1.25 3.69,-1.85 153.18,225.53 411.01,374.18 703.72,376.22 h 7.34 c 215.22,-1.54 411.47,-82.47 561.23,-214.83 M 1622.2,1672.16 c 93.21,137.19 147.78,302.77 147.78,481.14 0,339.02 -196.78,632.03 -482.3,771.2 -93.2,-137.21 -147.7,-302.83 -147.7,-481.2 0,-338.98 196.74,-631.95 482.22,-771.14 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 110,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4734.73,840.801 46.55,172.719 161.85,601.65 c 105.2,341.59 113.57,420.3 113.57,420.3 5.3,38.52 8.03,77.85 8.03,117.83 0,473.58 -383.9,857.5 -857.5,857.5 -133.1,0 -259.1,-30.33 -371.52,-84.45 m -1275.97,159.54 c 149.76,132.36 346.01,213.29 561.22,214.83 h 7.35 c 292.71,-2.04 550.53,-150.69 703.73,-376.22 1.23,0.6 2.44,1.26 3.67,1.85 m 144.05,-483.05 c 0,178.37 -54.5,343.99 -147.7,481.2 -285.53,-139.17 -482.3,-432.18 -482.3,-771.2 0,-178.37 54.57,-343.95 147.77,-481.14 285.48,139.19 482.23,432.16 482.23,771.14 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 110,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2845,3760.8 c 0,-157.4 -127.6,-285 -285,-285 -157.4,0 -285,127.6 -285,285 0,157.4 127.6,285 285,285 157.4,0 285,-127.6 285,-285 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 110,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2560,3085.89 c -177.77,-157.12 -290,-386.69 -290,-642.59 0,-255.9 112.23,-485.47 290,-642.59 177.77,157.12 290,386.69 290,642.59 0,255.9 -112.23,485.47 -290,642.59",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 110,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path52"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadeInLuxembourg);
export default __webpack_public_path__ + "static/media/made_in_luxembourg.bcfe236143ba01f78e30f0f61084a0ed.svg";
export { ForwardRef as ReactComponent };